import React, { useState, useEffect } from 'react';
import { api_url } from "../globalFunction/global_string";
import '../TrackingHook/TrackingHookCss.css';
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { SiteTitle } from "../SiteTitle";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function ViewTenTrackingDetail() {
    const [trackingData, setTrackingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const { buildDate, projectName, projectStartTime, projectEndTime } = location.state || {};
    const [modal, setModal] = useState(false); // 定義模態對話框狀態
    const [editData, setEditData] = useState({});  // 編輯按鈕使用
    const [reportCollapseStatus, setReportCollapseStatus] = useState({}); //追蹤報告標題收合使用
    const [isModaAddRecordlOpen, setIsModalAddRecordOpen] = useState(false);//新增單筆資料
    const [currentScanId, setCurrentScanId] = useState(null);  //暫時存放單筆新增資料的scanID
    const [currentProjectId, setCurrentProjectId] = useState(null);  //暫時存放單筆新增資料的ProjectId
    const [currentBuilddate, setCurrentBuilddate] = useState(null);  //暫時存放單筆新增資料的Builddate
    const [problemType, setProblemType] = useState(''); //新增問題類型
    const [riskLevel, setRiskLevel] = useState(''); //新增風險程度
    const [selectedFiles, setSelectedFiles] = useState([]); //選擇檔案放置位置
    const [notesFiles, setnotesFiles] = useState([]); //備註檔案
    const [countdowns, setCountdowns] = useState({});

    //利用scan_id來做分組函數       
    const groupByScanId = (data) => {
        return data.reduce((groups, item) => {
            if (!groups[item.scan_id]) {
                groups[item.scan_id] = [];
            }
            groups[item.scan_id].push(item);
            return groups;
        }, {});
    };
    function combinePdfData(trackingData) {
        const groupedData = {};
        trackingData.forEach(item => {
            const key = `${item.projectId}_${item.problemType}`;

            if (!groupedData[key]) {
                groupedData[key] = { ...item, problemSupportingInformationDetails: [], noteFileDetails: [] };
            }

            if (item.problemSupportingInformation && item.problemSupportingInformation.trim() !== '') {
                groupedData[key].problemSupportingInformationDetails.push({
                    fileName: item.problemSupportingInformation.split('\\').pop(),
                    filepath: item.problemSupportingInformation,
                    fileId: item.problemFileId
                });
            }
            if (item.noteFile && item.noteFile.trim() !== '') {
                groupedData[key].noteFileDetails.push({
                    fileName: item.noteFile.split('\\').pop(),
                    filepath: item.noteFile,
                    fileId: item.problemFileId
                });
            }
        });

        return Object.values(groupedData).map(item => ({
            ...item,
            problemSupportingInformation: item.problemSupportingInformationDetails.map(file => file.fileName).join(', '),
            problemSupportingInformationDetails: item.problemSupportingInformationDetails,
            noteFile: item.noteFileDetails.map(file => file.fileName).join(', '),
            noteFiles: item.noteFileDetails
        }));
    }





    //讀取清單方法
    const loadData = async () => {
        setIsLoading(true);
        let apiUrl = `${api_url}/api/TrackBackground/GetOneTenTrackBackgroundDetail`;
        const formData = new FormData();
        // formData.append('user_type', localStorage.getItem('login_user_type'));
        // formData.append('local_net_id', localStorage.getItem('login_user_net_id'));
        // formData.append('local_unit_id', localStorage.getItem('login_user_unit_id'));
        formData.append('projectName', projectName);
        formData.append('projectStartTime', projectStartTime);
        formData.append('projectEndTime', projectEndTime);
        formData.append("build_date", buildDate);

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (response.ok && data.statusCode === 200) {
                const groupedData = groupByScanId(data.row);
                setTrackingData(groupedData);
            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (buildDate, projectName, projectStartTime, projectEndTime) {
            loadData();
        }
    }, [buildDate, projectName, projectStartTime, projectEndTime]);

    if (isLoading) {
        return <div>正在加載...</div>;
    }

    if (error) {
        return <div>發生錯誤: {error}</div>;
    }

    // 修改按鈕事件處理
    const handleEdit = (data) => {
        const updatedData = {
            ...data,
        };
        setSelectedFiles([]);
        setEditData(updatedData);

        // 檢查 noteFiles 是否存在且为数组
        if (data.noteFiles && Array.isArray(data.noteFiles)) {
            const pdfFiles = data.noteFiles.map(file => ({
                id: file.fileId,
                name: file.fileName,
                path: `TrackBackGround\\${data.id}\\${file.fileName}`
            }));
            setnotesFiles(pdfFiles);
        } else {
            setnotesFiles([]);
        }

        toggleModal();
    };



    //刪除單筆問題類型 
    const handleDelete = async (id) => {
        console.log('Trying to delete item with id:', id);
        Swal.fire({
            title: '確定要刪除嗎?',
            text: "此操作無法撤回!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是的, 刪除它!',
            cancelButtonText: '取消'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let apiUrl = `${api_url}/api/TrackBackground/DelOneTenTrackBackgroundReportlist`;
                const formData = new FormData();
                formData.append("Id", id);
                try {
                    const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: { "Authorization": localStorage.getItem('accessToken') },
                        body: formData
                    });
                    const data = await response.json();
                    console.log(data.result.statusCode)
                    if (data.result.statusCode === 200) {
                        loadData();
                    } else {
                        Swal.fire({
                            title: '錯誤',
                            text: data.detail,
                            icon: 'error',
                            confirmButtonText: '好的'
                        });
                    }
                } catch (error) {
                    setError(error.message);
                } finally {
                    setIsLoading(false);
                }
            }
        });
    }

    // 更新數據的函數
    const handleUpdate = async () => {
        let apiUrl = `${api_url}/api/TrackBackground/PutOneTenTrackBackgroundData`;
        const formData = new FormData();
        formData.append("usertype", userType)
        formData.append("Id", editData.id);
        formData.append("projectId", editData.projectId);
        formData.append("scan_id", editData.scan_id);
        formData.append("note", editData.note || "");
        if (selectedFiles) {
            selectedFiles.forEach(file => {
                formData.append("noteFiles", file);
            });
        }
        if (userType === "S") {
            formData.append("problemReviewOpinions", editData.problemReviewOpinions || "");
            formData.append("problemReviewResults", editData.problemReviewResults || "99");
        } else if (userType === "M") {
            formData.append("problemPreliminaryOpinion", editData.problemPreliminaryOpinion || "");
            formData.append("problemPreliminaryResults", editData.problemPreliminaryResults || "99");
        } else if (userType === "N") {
            formData.append("problemPreliminaryOpinion", editData.problemPreliminaryOpinion || "");
            formData.append("problemPreliminaryResults", editData.problemPreliminaryResults || "99");
        }

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (data.statusCode === 200) {
                loadData();
                toggleModal();
            } else {
                Swal.fire({
                    title: '錯誤',
                    text: data.detail,
                    icon: 'error',
                    confirmButtonText: '好的'
                });
            }
        } catch (error) {
            setError(error.message);
            toggleModal();

        } finally {
            setIsLoading(false);
        }
    };

    // 切換模態對話框的顯示狀態
    const toggleModal = () => {
        setModal(!modal);
    };

    // 追蹤報告標題切換收合/展開狀態的函數
    const toggleReportCollapse = scanId => {
        setReportCollapseStatus(prevStatus => ({
            ...prevStatus,
            [scanId]: !prevStatus[scanId]
        }));
    };

    //刪除檔案
    const handleRemoveFile = async (fileId, index) => {
        // 移除本地狀態中的檔案
        setnotesFiles(currentFiles => {
            const updatedFiles = [...currentFiles];
            updatedFiles.splice(index, 1);
            // 更新 editData 中的 noteFile
            const updatedNoteFile = updatedFiles.map(file => file.path).join(', ');
            setEditData(currentEditData => ({ ...currentEditData, noteFile: updatedNoteFile }));
            return updatedFiles;
        });
        // 準備發送到後端的請求
        let formData = new FormData();
        formData.append('id', fileId);
        const apiUrl = `${api_url}/api/TrackBackground/DelProblemFile`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            if (!response.ok) {
                throw new Error('刪除文件時發生錯誤');
            }

            // 處理成功的響應
            const data = await response.json();
            if (data.statusCode === 200) {
                Swal.fire({
                    title: '成功!',
                    text: '此檔案已刪除成功',
                    icon: 'success',
                    confirmButtonText: '好的'
                })
            }
        } catch (error) {
            console.error('刪除文件時發生錯誤', error);
        }
    };

    const userType = localStorage.getItem('login_user_type');
    const username = localStorage.getItem('login_user_name');
    const net_name = localStorage.getItem('login_user_net_name');
    const unit_name = localStorage.getItem('login_local_unit_name');

    const handleDownload = async (filePath) => {
        const segments = filePath.split('\\');
        const fileNameWithExtension = segments.pop(); // 获取文件名
        const encodedFileName = encodeURIComponent(fileNameWithExtension); // 只对文件名进行编码
        const encodedPath = segments.join('/'); // 其余路径部分不需要编码
        const fileUrl = `${api_url}/${encodedPath}/${encodedFileName}`; // 组合URL
        console.log(fileUrl);

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) {
                throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURIComponent(encodedFileName)); // 使用解码的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Failed to fetch file:', error);
        }
    };


    const columns = [
        {
            name: '問題類型',
            selector: row => row.problemType,
            sortable: true,
            cell: row => <div className="wrap-text">{row.problemType}</div>
        },
        {
            name: '風險程度',
            selector: row => row.problemRiskLevel,
            sortable: true,
            cell: row => {
                const riskLevelMapping = {
                    '5': '重',
                    '4': '高',
                    '3': '中',
                    '2': '低',
                    '1': '訊息',
                    '0': '-'
                };
                return <div className="wrap-text">{riskLevelMapping[row.problemRiskLevel]}</div>;
            }
        },
        {
            name: '問題數量',
            selector: row => row.problemNumber,
            sortable: true,
            cell: row => <div className="wrap-text">{row.problemNumber}</div>
        },
        {
            name: '處理方式',
            selector: row => row.problemProcessingMethod,
            sortable: false,
            cell: row => {
                const ProcessingMethodMapping = {
                    '4': '已修補',
                    '3': '未修補',
                    '2': '誤判',
                    '1': '其他'
                };
                return <div className="wrap-text">{ProcessingMethodMapping[row.problemProcessingMethod]}</div>;
            }
        },
        {
            name: '改善回應',
            selector: row => row.problemimProvementResponse,
            sortable: false,
            cell: row => <div className="wrap-text">{row.problemimProvementResponse}</div>
        },
        {
            name: '佐證資料',
            selector: row => row.problemSupportingInformation,
            sortable: false,
            cell: row => {
                if (row.problemSupportingInformationDetails && Array.isArray(row.problemSupportingInformationDetails)) {
                    return (
                        <div className="wrap-text">
                            {row.problemSupportingInformationDetails.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>; // 如果沒有資料，顯示空白
                }
            }
        },
        {
            name: '備註',
            selector: row => row.note,
            sortable: false,
            cell: row => <div className="wrap-text">{row.note}</div>
        },
        {
            name: '備註檔案',
            selector: row => row.noteFile,
            sortable: false,
            cell: row => {
                if (row.noteFileDetails && Array.isArray(row.noteFileDetails)) {
                    return (
                        <div className="wrap-text">
                            {row.noteFileDetails.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>;
                }

            }
        },
        {
            name: '歷程記錄',
            selector: row => row.problemHistoryrecord,
            sortable: false,
            cell: row => <div className="wrap-text">{row.problemHistoryrecord}</div>
        },
        {
            name: '操作',
            cell: row => {

                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {
                            userType === 'N' || row.isTrackedreport === 2 ? null : (
                                <>

                                    {row.isadminbuildTrack ? (
                                        row.isNetTrack === true && row.problemReviewResults !== "3" && row.problemReviewResults !== "4" && (
                                            <>
                                                <Button color="secondary" onClick={() => handleEdit(row)}>修改</Button>
                                                <Button color="danger" onClick={() => handleDelete(row.id)}>删除</Button>
                                            </>
                                        )
                                    ) : null}
                                    {
                                        row.isNetbuildTrack ? (
                                            (row.projectStore === false || (userType !== 'S' && row.problemPreliminaryResults !== "3" && row.problemPreliminaryResults !== "4" && row.projectStore === true)) && (
                                                <>
                                                    <Button color="secondary" onClick={() => handleEdit(row)}>修改</Button>
                                                    <Button color="danger" onClick={() => handleDelete(row.id)}>删除</Button>
                                                </>
                                            )
                                        ) : null
                                    }
                                    {
                                        row.isUnitbuildTrack ? (
                                            (row.projectStore === false || (userType !== 'S' && row.problemPreliminaryResults !== "3" && row.problemPreliminaryResults !== "4" && row.projectStore === true)) && (
                                                <>
                                                    <Button color="secondary" onClick={() => handleEdit(row)}>修改</Button>
                                                    <Button color="danger" onClick={() => handleDelete(row.id)}>删除</Button>
                                                </>
                                            )
                                        ) : null
                                    }
                                </>
                            )
                        }
                    </div>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }

    ];

    if (userType === 'S') {
        columns.splice(6, 0,
            {
                name: '初審結果',
                selector: row => row.problemPreliminaryResults,
                sortable: false,
                cell: row => {
                    const ResultsLevelMapping = {
                        '4': '同意',
                        '3': '誤判',
                        '1': '後續追蹤',
                        '2': '不同意',
                    };
                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                }
            },
            {
                name: '初審意見',
                selector: row => row.problemPreliminaryOpinion,
                sortable: false,
                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
            },
            {
                name: '複審結果',
                selector: row => row.problemReviewResults,
                sortable: false,
                cell: row => {
                    const ResultsLevelMapping = {
                        '4': '同意',
                        '3': '誤判',
                        '1': '後續追蹤',
                        '2': '不同意',
                    };
                    return <div className="wrap-text">{ResultsLevelMapping[row.problemReviewResults]}</div>;
                }
            },
            {
                name: '複審意見',
                selector: row => row.problemReviewOpinions,
                sortable: false,
                cell: row => <div className="wrap-text">{row.problemReviewOpinions}</div>
            }
        );
    } else {
        columns.splice(6, 0,
            {
                name: '審核結果',
                selector: row => row.problemPreliminaryResults,
                sortable: false,
                cell: row => {
                    const ResultsLevelMapping = {
                        '4': '同意',
                        '3': '誤判',
                        '1': '後續追蹤',
                        '2': '不同意',
                    };
                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                }
            },
            {
                name: '審核意見',
                selector: row => row.problemPreliminaryOpinion,
                sortable: false,
                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
            }
        );
    }


    //單筆寄信功能
    const handleSendEmail = async (groupData, scanId) => {
        let apiUrl = api_url + '/api/TrackBackground/OneTenTrackBackgroundSendEmail';
        const formData = new FormData();
        formData.append('scanId', scanId);
        formData.append('build_date', groupData[0].build_date);


        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                if (data.result.statusCode === 200) {
                    Swal.fire('成功!', data.result.detail, 'success');

                    // 啟動倒數計時
                    setCountdowns(prev => ({ ...prev, [scanId]: 60 }));
                    const interval = setInterval(() => {
                        setCountdowns(prev => {
                            const currentCount = prev[scanId];
                            if (currentCount <= 1) {
                                clearInterval(interval);
                                return { ...prev, [scanId]: undefined }; // 到達0後清除該計時器
                            }
                            return { ...prev, [scanId]: currentCount - 1 };
                        });
                    }, 1000);
                } else {
                    Swal.fire('失敗!', data.result.detail, 'error');
                }
            } else {
                throw new Error("寄信失敗");
            }
        } catch (error) {
            console.error("寄信錯誤:", error);
        }
    }

    //單筆新增開起model
    const handleAddRecord = (groupData, scanId) => {
        setCurrentScanId(scanId);
        setCurrentProjectId(groupData[0].projectId)
        setCurrentBuilddate(groupData[0].build_date)
        setIsModalAddRecordOpen(true);
    }

    //單筆新增提交按鈕
    const handleAddNewRecord = async () => {
        if (!problemType) {
            Swal.fire({
                title: '錯誤!',
                text: '問題類型 是必填項且不能為空。',
                icon: 'error',
                confirmButtonText: '好的'
            });
            return;
        }

        const formData = new FormData();
        formData.append('scan_id', currentScanId);
        formData.append('ProjectId', currentProjectId);
        formData.append('ProblemType', problemType);
        const safeRiskLevel = riskLevel || '5';
        formData.append('ProblemRiskLevel', safeRiskLevel);
        formData.append('build_date', currentBuilddate);

        let apiUrl = api_url + '/api/TrackBackground/PostOneTenTrackBackgroundReportlist';

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                if (data.result.statusCode === 200) {
                    loadData();
                    setIsModalAddRecordOpen(false);
                    setCurrentScanId(null);
                    setCurrentProjectId(null);
                    setProblemType('');
                    setRiskLevel('');
                    setCurrentBuilddate('');
                }

            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            console.error('提交錯誤:', error);
        }
    }

    //單筆提交功能
    const handleSubmitRecord = async (groupData, scanId) => {
        const formData = new FormData();
        formData.append('scan_id', scanId);
        formData.append('ProjectId', groupData[0].projectId);
        formData.append('build_date', groupData[0].build_date);
        if (userType === 'S') {
            formData.append('IsadminTrack', 'true');
            formData.append('IsNetTrack', 'false');
            formData.append('IsUnitTrack', 'false');
        } else if (userType === 'M') {
            formData.append('IsNetTrack', 'true');
            formData.append('IsadminTrack', 'false');
            formData.append('IsUnitTrack', 'false');
        } else if (userType === 'N') {
            formData.append('IsUnitTrack', 'true');
            formData.append('IsadminTrack', 'false');
            formData.append('IsNetTrack', 'false');
        } else {
            formData.append('IsadminTrack', 'false');
            formData.append('IsNetTrack', 'false');
            formData.append('IsUnitTrack', 'false');
        }

        formData.append('usertype', userType);
        formData.append('username', username);

        let apiUrl = api_url + '/api/TrackBackground/PutOneTenTrackBackgroundReportlist';

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                if (data.result.statusCode === 200) {
                    loadData();
                    Swal.fire({
                        title: '成功',
                        text: '提交成功',
                        icon: 'success',
                        confirmButtonText: '好的'
                    });
                } else {
                    Swal.fire({
                        title: '錯誤',
                        text: '提交失敗',
                        icon: 'error',
                        confirmButtonText: '好的'
                    });
                }
            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            console.error('提交錯誤:', error);
        }
    }


    // 備註檔案提交功能
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const maxFiles = 10;
        const allowedExtensions = /\.(pdf|html?)$/i;

        const validFiles = files.filter(file => {
            return allowedExtensions.test(file.name) && file.size <= maxFileSize;
        });

        if (validFiles.length > maxFiles) {
            Swal.fire({
                title: '錯誤',
                text: `最多只能上傳 ${maxFiles} 個檔案。`,
                icon: 'error',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
            return;
        }

        if (validFiles.length !== files.length) {
            Swal.fire({
                title: '警告',
                text: '有些檔案大小超過限制或檔案類型不符合（只允許PDF和HTML）。',
                icon: 'warning',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        }

        // 更新狀態以儲存選擇的檔案
        setSelectedFiles(validFiles);
        setEditData({
            ...editData,
            noteFile: validFiles,
        });
    };



    const shouldShowSubmitButton = (groupData) => {
        return groupData.some(data => {
            if (data.isTrackedreport === 2) {
                return false;
            }
            if (data.isadminbuildTrack) {
                if (userType === 'S' && data.isNetTrack === true) {
                    return true;
                }
            }

            if (data.isNetbuildTrack) {
                if (userType === 'M' && (data.isUnitTrack === true || data.isNetAndTrack === true)) {
                    return true;
                }
            }

            if (data.isUnitbuildTrack) {
                if (userType === 'M' && (data.isUnitTrack === true || data.isNetAndTrack === true)) {
                    return true;
                }
            }
            return false;
        });
    };


    return (
        <div>
            <SiteTitle />
            {Object.entries(trackingData).map(([scanId, groupData], index) => (

                <div key={index} className="dataTable-wrapper">
                    <div className="dataTable-header">
                        <div className="header-item">區網名稱: {groupData[0].local_net_name}</div>
                        <div className="header-item">單位名稱: {groupData[0].local_unit_name}</div>
                        <div className="header-item">流水號: {groupData[0].projectreportname}</div>
                        <div className="header-item">
                            網站名稱: <a href={groupData[0].url_addr} target="_blank" rel="noopener noreferrer">{groupData[0].url_name}</a>
                            <Button onClick={() => toggleReportCollapse(scanId)} style={{ marginLeft: '10px' }}>
                                {reportCollapseStatus[scanId] ? '收起來' : '展開'}
                            </Button>
                            {userType !== 'N' && (
                                <Button onClick={() => handleSendEmail(groupData, scanId)}
                                    disabled={countdowns[scanId] > 0 || groupData.some(item => item.is_email === true) || groupData.some(item => item.projectStore === false) || groupData.some(item => item.isNetbuildTrack === true && userType === 'S')}
                                    style={{ marginLeft: '10px' }}>
                                    {countdowns[scanId] > 0 ? `${countdowns[scanId]}秒後可再次發送` : '發送郵件'}
                                </Button>
                            )}
                            <Button
                                onClick={() => handleAddRecord(groupData, scanId)}
                                style={{ marginLeft: '10px' }}
                                disabled={groupData.some(item => item.isNetbuildTrack === true && userType === 'S')}
                            >
                                單筆新增
                            </Button>


                            {
                                shouldShowSubmitButton(groupData) && userType !== 'N' && (
                                    <>

                                        <Button
                                            onClick={() => handleSubmitRecord(groupData, scanId)}
                                            style={{ marginLeft: '10px' }}
                                        >
                                            單筆提交
                                        </Button>

                                    </>
                                )
                            }
                        </div>
                    </div>
                    {!reportCollapseStatus[scanId] && (
                        <DataTable
                            noHeader
                            columns={columns}
                            // className="dataTable-container"
                            data={combinePdfData(groupData)}
                        />
                    )}
                </div>
            ))}


            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>修改數據</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="problemType">問題類型</Label>
                            <Input
                                type="text"
                                name="problemType"
                                id="problemType"
                                value={editData.problemType}
                                onChange={e => setEditData({ ...editData, problemType: e.target.value })}
                                readOnly
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="problemRiskLevel">風險程度</Label>
                            <Input
                                type="select"
                                name="problemRiskLevel"
                                id="problemRiskLevel"
                                value={editData.problemRiskLevel}
                                onChange={e => setEditData({ ...editData, problemRiskLevel: e.target.value })}
                                disabled
                            >
                                <option value="5">重</option>
                                <option value="4">高</option>
                                <option value="3">中</option>
                                <option value="2">低</option>
                                <option value="1">訊息</option>
                                <option value="0">-</option>
                            </Input>
                        </FormGroup>
                        {
                            editData.isadminbuildTrack ? (
                                <>
                                    <FormGroup>
                                        <Label for="problemPreliminaryResults">初審結果</Label>
                                        <Input
                                            type="select"
                                            name="problemPreliminaryResults"
                                            id="problemPreliminaryResults"
                                            value={editData.problemPreliminaryResults}
                                            onChange={e => userType === 'M' ? setEditData({ ...editData, problemPreliminaryResults: e.target.value }) : null}
                                            disabled={userType !== 'M'}
                                        >
                                            <option value="99">請選擇</option>
                                            <option value="4">同意</option>
                                            <option value="3">誤判</option>
                                            <option value="1">後續追蹤</option>
                                            <option value="2">不同意</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="problemPreliminaryOpinion">初審意見</Label>
                                        <Input
                                            type="textarea"
                                            name="problemPreliminaryOpinion"
                                            id="problemPreliminaryOpinion"
                                            value={editData.problemPreliminaryOpinion}
                                            onChange={e => userType === 'M' ? setEditData({ ...editData, problemPreliminaryOpinion: e.target.value }) : null}
                                            rows="8"
                                            style={{ resize: 'none', overflow: 'auto' }}
                                            readOnly={userType !== 'M'}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="problemReviewResults">複審結果</Label>
                                        <Input
                                            type="select"
                                            name="problemReviewResults"
                                            id="problemReviewResults"
                                            value={editData.problemReviewResults}
                                            onChange={e => userType === 'S' ? setEditData({ ...editData, problemReviewResults: e.target.value }) : null}
                                            disabled={userType !== 'S'}
                                        >
                                            <option value="99">請選擇</option>
                                            <option value="4">同意</option>
                                            <option value="3">誤判</option>
                                            <option value="1">後續追蹤</option>
                                            <option value="2">不同意</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="problemReviewOpinions">複審意見</Label>
                                        <Input
                                            type="textarea"
                                            name="problemReviewOpinions"
                                            id="problemReviewOpinions"
                                            value={editData.problemReviewOpinions}
                                            onChange={e => userType === 'S' ? setEditData({ ...editData, problemReviewOpinions: e.target.value }) : null}
                                            rows="8"
                                            style={{ resize: 'none', overflow: 'auto' }}
                                            readOnly={userType !== 'S'}
                                        />
                                    </FormGroup>
                                </>
                            ) : (
                                <>
                                    <FormGroup>
                                        <Label for="problemPreliminaryResults">審核結果</Label>
                                        <Input
                                            type="select"
                                            name="problemPreliminaryResults"
                                            id="problemPreliminaryResults"
                                            value={editData.problemPreliminaryResults}
                                            onChange={e => setEditData({ ...editData, problemPreliminaryResults: e.target.value })}
                                            readonly
                                        >
                                            <option value="99">請選擇</option>
                                            <option value="4">同意</option>
                                            <option value="3">誤判</option>
                                            <option value="1">後續追蹤</option>
                                            <option value="2">不同意</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="problemPreliminaryOpinion">審核意見</Label>
                                        <Input
                                            type="textarea"
                                            name="problemPreliminaryOpinion"
                                            id="problemPreliminaryOpinion"
                                            value={editData.problemPreliminaryOpinion}
                                            onChange={e => setEditData({ ...editData, problemPreliminaryOpinion: e.target.value })}
                                            rows="8"
                                            style={{ resize: 'none', overflow: 'auto' }}
                                        />
                                    </FormGroup>
                                </>
                            )
                        }
                        <FormGroup>
                            <Label for="note">備註</Label>
                            <Input
                                type="textarea"
                                name="note"
                                id="note"
                                value={editData.note}
                                onChange={e => setEditData({ ...editData, note: e.target.value })}
                                rows="8"
                                style={{ resize: 'none', overflow: 'auto' }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="noteFile">備註檔案</Label>
                            <Input
                                type="file"
                                name="noteFile"
                                id="noteFile"
                                multiple
                                onChange={handleFileChange}
                                accept=".pdf"
                            />
                            <div className="uploaded-files">
                                {notesFiles.map((file, index) => (
                                    <div key={index}>
                                        <span>{index + 1}. {file.name}</span>
                                        <Button onClick={() => handleRemoveFile(file.id, index)}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleUpdate}>保存</Button>{' '}
                    <Button color="secondary" onClick={toggleModal}>取消</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isModaAddRecordlOpen} toggle={() => setIsModalAddRecordOpen(false)}>
                <ModalHeader toggle={() => setIsModalAddRecordOpen(false)}>新增紀錄</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="problemType">問題類型</Label>
                            <Input
                                type="textarea"
                                name="problemType"
                                id="problemType"
                                value={problemType}
                                onChange={e => setProblemType(e.target.value)}
                                rows="10"
                                style={{ resize: 'none' }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="riskLevel">風險程度</Label>
                            <Input
                                type="select"
                                name="riskLevel"
                                id="riskLevel"
                                value={riskLevel}
                                onChange={e => setRiskLevel(e.target.value)}
                            >
                                <option value="5">重</option>
                                <option value="4">高</option>
                                <option value="3">中</option>
                                <option value="2">低</option>
                                <option value="1">訊息</option>
                                <option value="0">-</option>
                            </Input>
                        </FormGroup>

                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddNewRecord}>新增</Button>
                    <Button color="secondary" onClick={() => setIsModalAddRecordOpen(false)}>取消</Button>
                </ModalFooter>
            </Modal>


        </div>
    );



}

export default ViewTenTrackingDetail;
